import styled from 'styled-components';
import { basicColor, font, radius, transition } from '@/styles/template';
import { borderRadius } from 'polished';

export const Article = styled.div`
  ${font.basic};
  color: ${props => props.theme.color.Text};

  p {
    padding-bottom: 1rem;
  }

  b {
    font-weight: bold;
  }

  i {
    font-style: italic;
  }

  a {
    cursor: pointer;
    color: ${basicColor.primary};
    transition: ${transition.fastEnd};
    border-bottom: 1px solid transparent;

    &:hover {
      opacity: .8;
      border-bottom-color: ${basicColor.primary};
    }
  }

  ol {
    list-style-type: none;
    list-style-type: decimal !ie; /*IE 7- hack*/
    padding: 0;
    counter-reset: li-counter;
  }

  ol li {
    padding-left: 6rem;
    margin-bottom: 2rem;
    position: relative;
  }

  ol li:before {
    ${font.text.captionSmall};
    color: ${basicColor.primary};
    margin: 0 3rem 0 0;
    content: counter(li-counter);
    counter-increment: li-counter;
    border-radius: 50%;
    position: absolute;
    left: 0;
    display: flex;
    width: 4rem;
    height: 4rem;
    align-content: center;
    align-items: center;
    justify-content: center;
    line-height: 4rem;
    background: ${basicColor.primaryTransparent};
    white-space: nowrap;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  ul li {
    padding-left: 3rem;
    margin-bottom: 2rem;
    position: relative;
  }

  ul li:before {
    content: '•';
    font-size: 3rem;
    position: absolute;
    left: 0;
    top: 0;
    color: ${basicColor.primary};
  }

  u {
    text-decoration: none;
    padding-bottom: 2px;
    border-bottom: 1px solid;
  }

  s {
    text-decoration: line-through;
  }

  blockquote {
    ${font.accentL};
    padding: 2rem 1rem 2rem 3rem;
    position: relative;
  }

  blockquote::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
    border-radius: 2px;
    background: ${basicColor.primary};
  }

  pre {
    font-size: 2rem;
    overflow-x: auto;
    width: 100%;
    border-color: ${props => props.theme.color.LightItem};
    border-style: solid;
    border-width: 0 0 0 1rem;
    padding: 2rem;
    border-radius: ${radius.normal};
    background: ${props => props.theme.color.Background};
  }

  code {
    width: 100%;
    overflow: auto;
    border-radius: ${radius.normal};
  }

  img {
    max-width: 100%;
    height: auto;
    display: block;
  }

  figcaption, caption {
    ${font.basicXS};
    text-align: center;
    padding: 1rem 0 2rem;
  }

  figure {
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 2rem;
    min-width: max-content;
  }

  th, td {
    padding: 1rem;
    text-align: left;
  }

  td {
    vertical-align: middle;
  }

  th {
    background-color: ${basicColor.primaryTransparent};
    color: ${basicColor.primary};
  }

  tbody tr:nth-child(odd) {
    background-color: ${props => props.theme.color.Background};
  }

  --table-border-radius: ${radius.normal};

  table tr:first-child th:first-child {
    border-top-left-radius: var(--table-border-radius);
  }

  table tr:first-child th:last-child {
    border-top-right-radius: var(--table-border-radius);
  }

  table tr:last-child td:first-child {
    border-bottom-left-radius: var(--table-border-radius);
  }

  table tr:last-child td:last-child {
    border-bottom-right-radius: var(--table-border-radius);
  }
`